import clsx from 'clsx';
import { useState, useCallback, useEffect, useRef, memo } from 'react'
import useStore from '../../store/store';

const Recommend = memo(({ isPrem }) => {
  const getText = useCallback(
    () =>
      isPrem
        ? "Наиболее оптимальное сочетание очищения организма, расширенной диагностики, комфортных релаксирующих и SPA-процедур."
        : "Повышенная эффективность программы достигается за счёт ранней диагностики и расширенного перечня уходовых процедур. Программа позволяет за короткий срок получить эффект, сопоставимый с тем, который достигается при длительном пребывании на курорте.",
    [isPrem]
  );

  return (
    <div className="prog__type--recommend" title={getText()}>
      <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 9C0 8.46957 0.210714 7.96086 0.585787 7.58579C0.960859 7.21071 1.46957 7 2 7H8.32L7.36 2.43C7.34 2.33 7.33 2.22 7.33 2.11C7.33 1.7 7.5 1.32 7.77 1.05L8.83 0L15.41 6.58C15.78 6.95 16 7.45 16 8V18C16 18.5304 15.7893 19.0391 15.4142 19.4142C15.0391 19.7893 14.5304 20 14 20H5C4.17 20 3.46 19.5 3.16 18.78L0.139999 11.73C0.0499992 11.5 0 11.26 0 11V9ZM22 20H18V8H22V20Z"
          fill="#00B85D"
        />
      </svg>
      <span>Кивач рекомендует</span>
    </div>
  );
});

const ProgramCard = ({ people, programs }) => {
  const { activeGuest, activeRoom, updateGuest } = useStore();
  const [isOpenProgram, setIsOpenProgram] = useState(false);
  const [isOpenType, setIsOpenType] = useState(false);
  const [isOpenLength, setIsOpenLength] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState({
    program: people.program,
    program_type: people.program_type,
    program_length: people.program_length
  });
  const programRef = useRef(null);
  const typeRef = useRef(null);
  const lengthRef = useRef(null);
  
  const handleClickOutsideProgram = (event) => {
    if (programRef.current && !programRef.current.contains(event.target)) {
      setIsOpenProgram(false);
    }
  };
  const handleClickOutsideType = (event) => {
    if (typeRef.current && !typeRef.current.contains(event.target)) {
      setIsOpenType(false);
    }
  };

  const handleClickOutsideLength = (event) => {
    if (lengthRef.current && !lengthRef.current.contains(event.target)) {
      setIsOpenLength(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideProgram, true);
    document.addEventListener('click', handleClickOutsideType, true);
    document.addEventListener('click', handleClickOutsideLength, true);
    return () => {
      document.removeEventListener('click', handleClickOutsideProgram, true);
      document.removeEventListener('click', handleClickOutsideType, true);
      document.removeEventListener('click', handleClickOutsideLength, true);
    };
  }, []);
  // const toggleProgram = useCallback((programId) => {
  //   const curProg = programs.find(prog => prog.id === programId)
  //   setSelectedProgram((prevState) => ({
  //     ...prevState,
  //     program: {
  //       id: prevState?.program?.id === programId ? null : programId,
  //       name: curProg.name
  //     },
  //     program_length: curProg?.types[0]?.lengths[0],
  //     program_type: { ...curProg?.types[0] }
  //   }));
  //   updateGuest(activeRoom, people.id, {
  //     program: {
  //       id: programId,
  //       name: curProg.name
  //     },
  //     program_length: curProg?.types[0]?.lengths[0],
  //     program_type: { ...curProg?.types[0] }
  //   })
  // }, [activeRoom, people.id, programs, updateGuest]);

  const toggleProgram = useCallback(
    (programId) => {
      const currentProgram = programs.find((prog) => prog.id === programId);
      const defaultType = currentProgram.types[1] || currentProgram.types[0];
      const defaultLength = defaultType?.lengths[0];

      setSelectedProgram((prev) => {
        const isSameProgram = prev.program?.id === programId;
        return {
          program: isSameProgram ? null : { id: programId, name: currentProgram.name },
          program_type: isSameProgram ? null : { id: defaultType.id, name: defaultType.name },
          program_length: isSameProgram ? null : defaultLength,
        };
      });

    console.log(people);
      updateGuest(activeRoom, people.id, {
        program: { id: programId, name: currentProgram.name },
        program_type: { id: defaultType.id, name: defaultType.name },
        program_length: defaultLength,
      });
    },
    [activeGuest, activeRoom, programs, updateGuest]
  );


  // const toggleType = (typeId, program_type_name) => {
  //   setSelectedProgram((prevState) => ({
  //     ...prevState,
  //     program_type: {
  //       id: prevState?.program_type?.id === typeId ? null : typeId,
  //       name: program_type_name
  //     }
  //   }));
  //   updateGuest(activeRoom, people.id, {
  //     program_type: {
  //       id: typeId,
  //       name: program_type_name
  //     }
  //   })
  // };

    const toggleType = useCallback(
    (typeId, program_type_name) => {
      const currentProgram = programs.find((prog) => prog.id === selectedProgram.program?.id);
      const selectedType = currentProgram?.types.find((type) => type.id === typeId);
      const defaultLength = selectedType?.lengths[0];

      setSelectedProgram((prev) => ({
        ...prev,
        program_type: { id: typeId, name: program_type_name },
        program_length: defaultLength,
      }));

      updateGuest(activeRoom, people.id, {
        program_type: { id: typeId, name: program_type_name },
        program_length: defaultLength,
      });
    },
    [activeGuest, activeRoom, programs, selectedProgram.program?.id, updateGuest]
  );

  // const toggleLength = (len) => {
  //   setSelectedProgram((prevState) => ({
  //     ...prevState,
  //     program_length: prevState?.program_length === len ? null : len
  //   }));

  //   updateGuest(activeRoom, activeGuest, { program_length: len })
  // };

  const toggleLength = useCallback(
    (len) => {
      setSelectedProgram((prev) => ({
        ...prev,
        program_length: prev.program_length === len ? null : len,
      }));
      updateGuest(activeRoom, people.id, { program_length: len });
    },
    [activeGuest, activeRoom, updateGuest]
  );

  const renderTypes = (progId) => {
    const types = programs.find(program => program.id === progId)?.types || [];

    if (types.length === 1) return null;

    return (
      <div>
        <div
          ref={typeRef}
          className={clsx([
            'ProgramChoiceMobile__prog-title',
            isOpenType && 'open',
            people.program_type.id !== null && 'selected'
          ])}
          onClick={() => setIsOpenType(prev => !prev)}
        >
          {people.program_type.id === null ? 'Вариант программы' : people.program_type.name}

          <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 6.75L6.5 1.25L12 6.75" stroke="#434548" strokeLinecap="round" />
          </svg>
        </div>
        {progId !== null && <div className={clsx([isOpenType && 'open', 'ProgramChoiceMobile__list'])}>
          {/* {
            types.length > 0 && types?.map(
              (type) => (
                <div key={type.name} onClick={() => toggleType(type.id, type.name)}>
                  {type.name}
                </div>
              )
            )
          } */}
          {types.map((type) => (
            <div key={type.id}>
              <label>
                <input
                  type="checkbox"
                  onChange={() => toggleType(type.id, type.name)}
                  checked={selectedProgram?.program_type?.id === type.id}
                />
                <div className="prog__type">
                  {type.name}{" "}
                  {type.name.includes("Премиум") && (selectedProgram.program?.name.includes("Детокс") || selectedProgram.program?.name.includes("Общее")) ? (
                    <Recommend isPrem={selectedProgram.program?.name.includes("Детокс")} />
                  ) : null}
                </div>
              </label>
            </div>
          ))}
        </div>
        }
      </div>
    )
  }

  const renderLengths = (progId) => {
    const types = programs.find(program => program.id === progId)?.types || [];
    const lengths = types.find(type => type.id === selectedProgram.program_type.id)?.lengths || [];
    return (
      <div>
        <div
          ref={lengthRef}
          className={clsx([
            'ProgramChoiceMobile__prog-title',
            isOpenLength && 'open',
            people.program_length !== null && 'selected'
          ])}
          onClick={() => setIsOpenLength(prev => !prev)}
        >
          {people.program_length === null ? 'Длительность' : people.program_length + ' дней'}

          <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 6.75L6.5 1.25L12 6.75" stroke="#434548" strokeLinecap="round" />
          </svg>
        </div>
        {progId !== null && <div className={clsx([isOpenLength && 'open', 'ProgramChoiceMobile__list'])}>
          {
            lengths.length > 0 && lengths?.map(
              (len) => (
                <div key={len} onClick={() => toggleLength(len)}>
                  {`${len} дней`}
                </div>
              )
            )
          }
        </div>}
      </div>)
  }

  return (<div className='ProgramChoiceMobile__card'>
    <span className='ProgramChoiceMobile__card-title'>{people.name}</span>
    <div>
      <div
        ref={programRef}
        className={clsx([
          'ProgramChoiceMobile__prog-title',
          isOpenProgram && 'open',
          people.program.id !== null && 'selected'
        ])}
        onClick={() => setIsOpenProgram(prev => !prev)}
      >
        {people.program.id === null ? 'Программа' : people.program.name}

        <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 6.75L6.5 1.25L12 6.75" stroke="#434548" strokeLinecap="round" />
        </svg>
      </div>
      <div className={clsx([isOpenProgram && 'open', 'ProgramChoiceMobile__list'])}>
        {
          programs.length > 0 ? programs?.map(
            (prog) => (
              <div key={prog.name} onClick={() => toggleProgram(prog.id)}>
                {prog.name}
              </div>
            )
          ) : <span>Нет подходящих программ</span>
        }
      </div>
    </div>

    {renderTypes(people.program.id)}
    {renderLengths(people.program.id)}
  </div>)
}

export default ProgramCard